/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PatchApiV1NotificationMobileAppNotificationidCancelMutationResponse,
  PatchApiV1NotificationMobileAppNotificationidCancelPathParams,
  PatchApiV1NotificationMobileAppNotificationidCancel400,
  PatchApiV1NotificationMobileAppNotificationidCancel401,
  PatchApiV1NotificationMobileAppNotificationidCancel500,
} from "../../types/notificationMobileAppController/PatchApiV1NotificationMobileAppNotificationidCancel.ts";

function getPatchApiV1NotificationMobileAppNotificationidCancelUrl(
  notificationId: PatchApiV1NotificationMobileAppNotificationidCancelPathParams["notificationId"],
) {
  const res = {
    method: "PATCH",
    url: `/api/v1/notification/mobile-app/${notificationId}/cancel` as const,
  };
  return res;
}

/**
 * @description Cancela os jobs Hangfire dos itens com status Pendente (1) ou Agendado (2) e marca como Rascunho (6). **(Requer Authorization para autenticação)**
 * @summary Cancela uma notificação pendente ou agendada (Requer Authorization para autenticação)
 * {@link /api/v1/notification/mobile-app/:notificationId/cancel}
 */
export async function patchApiV1NotificationMobileAppNotificationidCancel(
  notificationId: PatchApiV1NotificationMobileAppNotificationidCancelPathParams["notificationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PatchApiV1NotificationMobileAppNotificationidCancelMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1NotificationMobileAppNotificationidCancel400
      | PatchApiV1NotificationMobileAppNotificationidCancel401
      | PatchApiV1NotificationMobileAppNotificationidCancel500
    >,
    unknown
  >({
    method: "PATCH",
    url: getPatchApiV1NotificationMobileAppNotificationidCancelUrl(
      notificationId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
